// extracted by mini-css-extract-plugin
export default {"home-page":"HomePage_home-page__vNRGa","home-page__message":"HomePage_home-page__message__hp5vT","home-page__title":"HomePage_home-page__title__MfNgh"};